module.exports = __webpack_public_path__ + "media/images/workplace/emojis/happy-5e149e57f97a20601e427b66aa899dae.png";